import classes from './MockLoadingBlock.module.css'

const MockLoadingBlock = ({height, noBevel, noMargin, width}) => {
    return <div className={`${classes.block} ${noBevel ? classes.no_bevel : ''} ${noMargin ? classes.no_margin : ''}`} style={{height: height, width: width}}></div>
}

export default MockLoadingBlock